import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "../../../../../shared/components/index";
import { PartNumber } from "../../../../../shared/models/partNumber.model";
import { PartNumberFormComponent } from "../../forms/part-number-form/part-number-form.component";
import { Log } from "ng2-logger";
import { FormType } from "@app/tool/details/components/form-type.enum";

@Component({
    selector: 'app-part-number-form-modal',
    templateUrl: './part-number-form-modal.component.html',
    styleUrls: ['./part-number-form-modal.component.scss']
})
export class PartNumberFormModalComponent {
    _logger = Log.create(PartNumberFormModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(PartNumberFormComponent, {static: true}) partNumberForm: PartNumberFormComponent;

    @Input() availablePartNumbers: PartNumber[];
    @Input() selectedPartNumbers: PartNumber[];
    @Input() isLoading;

    @Output() updatePartNumbers = new EventEmitter<any>();

    validationErrors;
    showPartNumberFormValidations = false;


    constructor() {
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    firePartNumbersUpdate() {
        if (!this.isFormValid()) {
            this._logger.info('updatePartNumbers:: Form is invalid');
            return;
        }

        const selectedPartNumbersValue = this.partNumberForm.value();
        this._logger.info('updatePartNumbers:: Selected part numbers are', selectedPartNumbersValue);

        this.updatePartNumbers.emit({
            type: FormType.PART_NUMBER,
            partNumberIds: selectedPartNumbersValue.partNumberIds
        });
    }

    private reset() {
        this.showPartNumberFormValidations = false;
        this.validationErrors = {};
        this.partNumberForm.reset();
        this.modal.close();
    }

    private isFormValid() {
        this.validationErrors = {};
        this.showPartNumberFormValidations = true;
        return this.partNumberForm.isFormValid();
    }
}
